import { useForm, Controller } from 'react-hook-form';
import { InputTextarea } from 'primereact/inputtextarea';
import { CustomButton } from '../../../components/CustomButton';
import { classNames } from 'primereact/utils';
import { useDispatch, useSelector } from 'react-redux';
import {
  changestepcount,
  resetBroadcast,
  setBroadcastDetails,
} from '../../../reducers/wca/share-message/share-message-slice';
import TemplatePreview from '../../../components/CampaignTemplatePreviewWCA';
import { InputText } from 'primereact/inputtext';
import { formateMessageInput, validateMediaSize, blob } from '../../../utils/templateUtils';
import { useState, useRef } from 'react';
import { Text } from '../../../components/Text';
import { useEffect } from 'react';
import { Badge } from 'primereact/badge';
import CustomBreadcrumb from '../../../components/CustomBreadcrumb';
import { useNavigate, useParams } from 'react-router-dom';
import { resetAll } from '../../../reducers/productTableSlice';
import { compressImg } from '../../../utils/templateUtils';
import { useUtility } from '../../../context/UtilityContext';
import { getTemplateById_WCA } from '../../../reducers/wca/template/template-action';
import { API_GET_IMG_URL, API_UPLOAD_IMG } from '../../../api/chat.service';

const addsteps = (name, value, url, show = true, panel = false) => {
  return { name, value, url, show, panel };
};

export const Template = ({ toast }) => {
  const [tempVariables, setTempvariables] = useState([]);
  const [file, setFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [videoPreview, setVideoPreview] = useState(null);
  const [documentPreview, setDocumentPreview] = useState(null);
  const [templateButtons, setTemplateButtons] = useState([]);

  const { completeSteps, campaignName, broadcastdetails, selectedTemplate, mode, campDetails } =
    useSelector((state) => state.shareMessageWCA);
  const { id } = useParams();
  const { selectedMetadataId } = useUtility();

  const defaultValues = {
    templateType: '',
    header: '',
    footer: '',
    message: '',
  };

  const {
    control,
    formState: { errors, isValid },
    handleSubmit,
    watch,
    reset,
    setValue,
  } = useForm(defaultValues);
  useEffect(() => {
    if (mode === 'update') {
      setValue('templateType', campDetails.templateType);
      setValue('message', campDetails?.message);
      setValue('header', campDetails?.header);
      setValue('footer', campDetails?.footer);
    }
  }, []);

  //function form get error message
  const getFormErrorMessage = (name) => {
    return errors[name] && <small className="p-error">{errors[name].message}</small>;
  };
  useEffect(() => {
    if (selectedTemplate?.id) {
      dispatch(
        getTemplateById_WCA({
          metadataid: selectedMetadataId,
          templateID: selectedTemplate?.id,
          templateName: selectedTemplate?.name,
        }),
      )
        .unwrap()
        .then((res) => console.log('res', res));
    }
    return () => {};
  }, []);

  useEffect(() => {
    if (!selectedTemplate?.components) return;

    console.log('selectedTemplate', selectedTemplate);

    const body = selectedTemplate.components.find((c) => c.type === 'BODY');

    const bodyText = body?.text || '';

    setValue('message', bodyText);

    // 👉 Extract variables from BODY text (IMPORTANT CHANGE)
    const matches = bodyText.match(/{{(.*?)}}/g) || [];

    const bodyVars = matches.map((match) => {
      const key = match.replace(/[{}]/g, '');

      return {
        id: Math.random(),
        variableKey: key,
        variableName: match,
        variableValue: '',
      };
    });

    setTempvariables(bodyVars);
  }, [selectedTemplate, setValue]);

  const dispatch = useDispatch();
  const mediaFileRef = useRef();

  useEffect(() => {
    if (broadcastdetails?.media) {
      blob(broadcastdetails?.media)
        .then((blobFile) => {
          let fname = broadcastdetails?.configData?.filename;
          return new File([blobFile], fname ? fname : `file.${blobFile.type.split('/')[1]}`, {
            type: blobFile.type,
          });
        })
        .then((e) => {
          const reader = new FileReader();
          const selectedFile = e;
          if (selectedFile) {
            setFile(selectedFile);
            reader.readAsDataURL(selectedFile);
            reader.onload = (readerEvent) => {
              if (selectedFile.type.includes('image')) {
                setImagePreview(readerEvent.target.result);
              } else if (selectedFile.type.includes('video')) {
                setVideoPreview(readerEvent.target.result);
              } else if (selectedFile.type.includes('pdf')) {
                setDocumentPreview(readerEvent.target.result);
              }
            };
          }
        })
        .catch((e) => {
          toast?.current?.show({
            severity: 'error',
            detail: 'Unable To Fetch File',
          });
        });
    }
  }, [broadcastdetails]);

  const previewFile = (e) => {
    const reader = new FileReader();
    const selectedFile = e.target.files[0];

    if (!selectedFile) return;

    // reset previews
    setImagePreview(null);
    setVideoPreview(null);
    setDocumentPreview(null);

    setFile(selectedFile);

    if (selectedFile.type.includes('image')) {
      compressImg(selectedFile).then((compressed) => {
        setFile(compressed);
      });
    }

    reader.readAsDataURL(selectedFile);

    reader.onload = (readerEvent) => {
      if (selectedFile.type.includes('image')) {
        setImagePreview(readerEvent.target.result);
      } else if (selectedFile.type.includes('video')) {
        setVideoPreview(readerEvent.target.result);
      } else {
        setDocumentPreview(readerEvent.target.result);
      }
    };
  };

  const handleEditVariable = (e, id) => {
    let updateVariableData = tempVariables.map((item) => {
      if (item.id !== id) return item;
      else return { ...item, variableValue: e.target.value };
    });
    setTempvariables(updateVariableData);
  };

  const steps = [];
  steps.push(addsteps('Information', 'info', `${id ? `/runcampaign/${id}` : `/runcampaign/new`}`));
  steps.push(
    addsteps(
      'Edit Template',
      'info',
      `${id ? `/runcampaign/selecttemplate/${id}` : `/runcampaign/selecttemplate/new`}`,
      true,
      true,
    ),
  );
  // steps.push(
  //   addsteps(
  //     'Select Product',
  //     'prod',
  //     `${id ? `/runcampaign/selectproducts/${id}` : `/runcampaign/selectproducts/new`}`,
  //     campaignType === 'product',
  //   ),
  // );
  steps.push(
    addsteps(
      'Select Customer',
      'cust',
      `${id ? `/runcampaign/selectcustomer/${id}` : `/runcampaign/selectcustomer/new`}`,
    ),
  );
  steps.push(
    addsteps(
      'Schedule Campaign',
      'camp',
      `${id ? `/runcampaign/schedule/${id}` : `/runcampaign/schedule/new`}`,
    ),
  );

  // const buildVariablesPayload = () => {
  //   let bodyValues = {};

  //   tempVariables.forEach((item) => {
  //     if (item.variableValue) {
  //       bodyValues[item.variableKey] = item.variableValue;
  //     }
  //   });

  //   return {
  //     HEADER: {},
  //     BODY: Object.keys(bodyValues).length ? { values: bodyValues } : {},
  //     FOOTER: {},
  //     BUTTONS: {},
  //   };
  // };
  const headerComponent = selectedTemplate?.components?.find((c) => c.type === 'HEADER');

  const headerFormat = headerComponent?.format; // IMAGE / VIDEO / DOCUMENT / TEXT
  const buildVariablesPayload = (fileUrl = '') => {
    let bodyValues = {};

    tempVariables.forEach((item) => {
      if (item.variableValue) {
        bodyValues[item.variableKey] = item.variableValue;
      }
    });

    let headerObj = {};

    if (headerFormat === 'IMAGE' && fileUrl) {
      headerObj = {
        IMAGE: {
          link: fileUrl,
        },
      };
    }

    if (headerFormat === 'VIDEO' && fileUrl) {
      headerObj = {
        VIDEO: {
          link: fileUrl,
        },
      };
    }

    if (headerFormat === 'DOCUMENT' && fileUrl) {
      headerObj = {
        DOCUMENT: {
          link: fileUrl,
        },
      };
    }

    return {
      HEADER: headerObj,
      BODY: Object.keys(bodyValues).length ? bodyValues : {},
      FOOTER: {},
      BUTTONS: {},
    };
  };

  const uploadMediaToS3 = async (file) => {
    try {
      // 1. Get signed URL
      const respUrl = await API_GET_IMG_URL();

      const uploadUrl = respUrl.data.src;
      const fileUrl = respUrl.data.url;
      console.log(' file.type', file.type);

      // 2. Upload file to S3
      await API_UPLOAD_IMG(uploadUrl, file, file.type);

      // 3. Return public URL
      return fileUrl;
    } catch (err) {
      console.log('S3 Upload Error:', err);
      throw err;
    }
  };

  // handle sumbit formdata
  const onSubmit = async (data) => {
    const watchTempType = watch('templateType');
    // ✅ Check variables
    const emptyVariables = tempVariables.filter(
      (item) => !item.variableValue || item.variableValue.trim() === '',
    );

    if (emptyVariables.length > 0) {
      toast?.current?.show({
        severity: 'warn',
        detail: 'Please fill all variable values.',
      });
      return;
    }

    const hasVariables = tempVariables.length > 0;

    if (hasVariables && ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(headerFormat) && !file) {
      toast?.current?.show({
        severity: 'warn',
        detail: 'Please upload file',
      });
      return;
    }
    const { id } = selectedTemplate;
    let fileUrl = '';

    try {
      // 👉 Upload file only if header is media
      if (file && ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(headerFormat)) {
        fileUrl = await uploadMediaToS3(file);
      }
      const variablesPayload = buildVariablesPayload(fileUrl);
      console.log('data', data);

      let configData = {
        ...broadcastdetails?.configData,
        campaignName: campaignName,
        templateId: id,
        variables: variablesPayload,
      };

      console.log('config data', configData);

      dispatch(
        setBroadcastDetails({
          configData,
          // media: file ? window.URL.createObjectURL(file) : file,
        }),
      );

      // if (!id) {
      //   dispatch(dispatch(changestepcount(campaignType === 'product' ? 2 : 3)));
      // }

      navigate(`${id ? `/runcampaign/selectcustomer/${id}` : `/runcampaign/selectcustomer/new`}`);

      // navigate(
      //   `${
      //     campaignType === 'product'
      //       ? `${id ? `/runcampaign/selectproducts/${id}` : `/runcampaign/selectproducts/new`}`
      //       : `${id ? `/runcampaign/selectcustomer/${id}` : `/runcampaign/selectcustomer/new`}`
      //   }`,
      // );
    } catch (error) {
      console.log('error', error.message);
      toast?.current?.show({
        severity: 'error',
        detail: 'Something went wrong',
      });
    }
  };

  const switchform = (link) => {
    navigate(link);
  };
  const navigate = useNavigate();
  const { navigation, setAlert } = useUtility();

  const cancelBroadcast = () => {
    dispatch(resetBroadcast());
    dispatch(resetAll());
    navigation(`${id ? `/campaigns/${id}` : `/campaigns`}`);
  };

  useEffect(() => {
    if (completeSteps === 0) {
      navigate(`${id ? `/runcampaign/${id}` : `/runcampaign/new`}`);
    }
  }, [completeSteps]);

  const headerContainer = () => {
    const mediaSelect = (icon, accept) => {
      let isValid = true;
      let acceptedSize = '';

      if (file) {
        const res = validateMediaSize(file?.size, headerFormat?.toLowerCase());
        isValid = res?.isValid;
        acceptedSize = res?.acceptedSize;
      }

      return !file ? (
        <div>
          <input ref={mediaFileRef} type="file" accept={accept} hidden onChange={previewFile} />

          <button
            type="button"
            className="w-full temp-img flex gap-3 p-3 my-2 cursor-pointer"
            onClick={() => mediaFileRef.current.click()}
          >
            <i className={`pi ${icon}`} />
            <Text type={'sub-heading'} cust="capitalize">
              Choose {headerFormat.toLowerCase()}
            </Text>
          </button>
        </div>
      ) : (
        <>
          <div className="temp-img-upload">
            <div className="flex gap-2 justify-content-between align-items-center">
              <div className="flex gap-2 align-items-center">
                <i className={`pi ${icon}`} />
                <Text type={'sub-heading'} cust="capitalize">
                  {file.name}
                </Text>
              </div>

              <i className="pi pi-trash cursor-pointer" onClick={handleDeleteMedia} />
            </div>
          </div>

          {!isValid && (
            <div className="mb-2">
              <small className="p-error">
                {headerFormat.toLowerCase()} size should be less than {acceptedSize} MB.
              </small>
            </div>
          )}
        </>
      );
    };

    const handleDeleteMedia = () => {
      setFile(null);
      setImagePreview(null);
      setVideoPreview(null);
      setDocumentPreview(null);
    };

    switch (headerFormat) {
      case 'IMAGE':
        return mediaSelect('pi-image', 'image/jpeg, image/png');

      case 'VIDEO':
        return mediaSelect('pi-video', 'video/mp4');

      case 'DOCUMENT':
        return mediaSelect('pi-file', '.pdf,.doc,.docx');

      default:
        return null;
    }
  };

  const itemslist = [{ label: 'Run Campaign', url: '' }];
  return (
    <div className="w-full m-auto ">
      <div className="w-full m-auto overflow-x-auto">
        <CustomBreadcrumb home={{ label: 'Campaign', url: '/campaigns' }} itemslist={itemslist} />
      </div>
      <div className="p-3 pt-1">
        <div
          className="w-full m-auto flex flex-row justify-content-between align-items-center  my-2 overflow-x-auto border-round-sm "
          style={{ background: '#f2f2f2' }}
        >
          <div className="p-2 py-3 flex flex-row ">
            {steps.map((x, index) => {
              return (
                <div
                  key={index}
                  className="flex flex-row gap-2 mr-3 cursor-pointer"
                  onClick={() => {
                    index <= completeSteps && x.show && switchform(x.url);
                  }}
                >
                  <div>
                    <Badge
                      value={index + 1}
                      style={{
                        background: index <= completeSteps ? `#1c738e` : `grey`,
                        opacity: `${x.show ? `1` : `.5`}`,
                      }}
                    />
                  </div>
                  <div
                    className={`white-space-nowrap  ${
                      x.panel ? `border-none border-bottom-1 border-solid` : ``
                    }`}
                    style={{ borderColor: '#1c738e' }}
                  >
                    {x.name}
                  </div>
                </div>
              );
            })}
          </div>
          <div className="flex flex-row gap-2 align-items-center px-2">
            <div className="font-medium text-sm cursor-pointer" onClick={cancelBroadcast}>
              Cancel
            </div>
            <div>
              <CustomButton
                varient="plain-button w-full"
                type="reset"
                onClick={() => {
                  navigate(`${id ? `/runcampaign/${id}` : `/runcampaign/new`}`);
                }}
                label={'Back'}
              />
            </div>
            <div>
              <CustomButton
                varient="filled w-full"
                type="submit"
                onClick={handleSubmit(onSubmit)}
                label={<span>Save&nbsp;&&nbsp;Continue</span>}
              />
            </div>
          </div>
        </div>
        <div className="flex w-full flex-wrap-reverse pt-3">
          <div className="flex flex-column w-8 flex-grow-1 lg:flex-grow-0 xl:flex-grow-0 justify-content-between">
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid w-full">
              {['IMAGE', 'VIDEO', 'DOCUMENT'].includes(headerFormat) && headerContainer()}
              <div className="field mt-2">
                <label htmlFor="message">
                  Template&nbsp;Name&nbsp;&nbsp;:&nbsp;&nbsp;
                  <span className="capitalize text-base font-bold">{selectedTemplate?.name}</span>
                </label>
              </div>
              <div className="field mt-2">
                <label htmlFor="message">Body *</label>
                <Controller
                  name="message"
                  control={control}
                  rules={{ required: 'message is required.' }}
                  render={({ field, fieldState }) => (
                    <InputTextarea
                      {...field}
                      className={classNames({
                        'p-invalid': fieldState.invalid,
                      })}
                      rows={6}
                      autoResize
                      maxLength={1028}
                      placeholder="Enter your message (max 1028 chars)"
                      disabled
                    />
                  )}
                />
                {getFormErrorMessage('message')}
                <div className="my-2">
                  {tempVariables.map((item, i) => (
                    <div key={item.id} className="flex gap-2 my-3">
                      <div className="w-3">
                        {i === 0 && <label>Variable</label>}
                        <InputText value={item.variableName} disabled />
                      </div>

                      <div className="flex-grow-1">
                        {i === 0 && <label>Value</label>}
                        <InputTextarea
                          rows={1}
                          autoResize
                          value={item.variableValue}
                          onChange={(e) => handleEditVariable(e, item.id)}
                          placeholder="Enter value"
                          required
                        />
                        {!item.variableValue && (
                          <small className="p-error">Value is required</small>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {false && templateButtons.length !== 0 && (
                <div className="field">
                  <Text>Buttons</Text>
                  <div className="button-preview-container w-full mb-2 py-2">
                    {templateButtons?.map((item) =>
                      item.isSaved ? (
                        <div
                          className="m-2  flex justify-content-between p-3"
                          style={{ backgroundColor: '#005068' }}
                          key={item.id}
                        >
                          <Text type={'sub-heading'} color={'#ffffff'}>
                            {item.text}
                          </Text>
                        </div>
                      ) : (
                        <div className="m-2 relative" key={item.id}></div>
                      ),
                    )}
                  </div>
                </div>
              )}
            </form>
          </div>
          <div
            className={`flex flex-grow-1 justify-content-center mob-preview-container `}
            style={{ minHeight: '620px' }}
          >
            <div className="relaive w-full flex justify-content-center">
              <div className="static lg:fixed xl:fixed">
                <div className="flex flex-column justify-content-center align-items-center">
                  <div className="min-h-full">
                    <TemplatePreview
                      header={watch('header')}
                      footer={watch('footer')}
                      buttons={templateButtons}
                      content={formateMessageInput(watch('message'), 'preview', tempVariables)}
                      videoPreview={videoPreview}
                      documentPreview={documentPreview}
                      imagePreview={imagePreview}
                      file={file}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
